import request from '../../utils/request'
import {
  GETPERMISSIONFUCLIST,
  GETPERMISSIONFUNCTREELIST,
  GETPERMISSIONLIST,
  GETPERMISSIONLISTS,
  GETPERMISSIONMENULIST,
  GETPERMISSIONMENUTREELIST,
  GETPERMISSIONORGLIST,
  GETPERMISSIONORGLISTS,
  GETPERMISSIONUSERLIST,
  GETPERMISSIONUSERLISTS,
} from '../constants'

/**
 * 获取角色列表
 * @param {*} params
 * @returns
 */
export const getPermissionList = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/permission/role/', {
      params,
    })
    // console.log(res.data.data)
    const init = (arr) => {
      arr = arr.map((item) => {
        item.title = item.role_name
        item.description = item.role_name
        item.option = item.role_name
        item.key = item.role_id
        return item
      })
      return arr
    }
    let arr = init(res.data.data.data)
    dispatch({
      type: GETPERMISSIONLIST,
      payload: {
        arr,
        total: res.data.data.total,
      },
    })
  }
}

export const getPermissionLists = (params, isLoading) => {
  return async (dispatch) => {
    const res = await request.get('sys/permission/role/', {
      params,
      isLoading,
      // headers: {
      //   isLoading: isLoading,
      // },
    })
    const init = (arr) => {
      arr = arr.map((item) => {
        item.title = item.role_name
        item.description = item.role_name
        item.option = item.role_name
        item.key = item.role_id
        return item
      })
      return arr
    }
    let arr = init(res.data.data)
    // console.log(res.data.data)
    dispatch({
      type: GETPERMISSIONLISTS,
      payload: arr,
    })
  }
}

export const addPermission = (values) => {
  return async (dispatch) => {
    const res = await request.post('sys/permission/role/', values)
    console.log(res)
  }
}

export const editPermission = (values) => {
  return async (dispatch) => {
    const res = await request.put(`sys/permission/role/${values.id}/`, values)
    console.log(res)
  }
}

export const delPermission = (id) => {
  return async (dispatch) => {
    await request.delete(`sys/permission/role/${id}/`)
  }
}

export const batchDelPermission = (params) => {
  return async (dispatch) => {
    await request.delete('sys/permission/role/', {
      params,
    })
  }
}

export const getPermissionUserList = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/permission/role/user/', {
      params,
    })
    console.log(res)
    dispatch({
      type: GETPERMISSIONUSERLIST,
      payload: res.data.data,
    })
  }
}

export const getPermissionUserLists = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/permission/role/user/', {
      params,
    })
    console.log(res)
    dispatch({
      type: GETPERMISSIONUSERLISTS,
      payload: res.data.data,
    })
  }
}

export const getPermissionOrgList = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/permission/role/org/', {
      params,
    })
    // console.log(res)
    dispatch({
      type: GETPERMISSIONORGLIST,
      payload: res.data.data,
    })
  }
}
export const getPermissionOrgLists = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/permission/role/org/', {
      params,
    })
    // console.log(res)

    dispatch({
      type: GETPERMISSIONORGLISTS,
      payload: res.data.data,
    })
  }
}

export const getPermissionMenuTreeList = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/permission/role/menu/tree/', {
      params,
    })
    // console.log(res)
    dispatch({
      type: GETPERMISSIONMENUTREELIST,
      payload: res.data.data,
    })
  }
}
export const getPermissionFuncTreeList = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/permission/role/func/tree/', {
      params,
    })
    // console.log(res)
    dispatch({
      type: GETPERMISSIONFUNCTREELIST,
      payload: res.data.data,
    })
  }
}

export const batchAddUser = (values) => {
  return async (dispatch) => {
    const res = await request.post('sys/permission/role/user/', values)
    console.log(res)
  }
}

export const batchDelUser = (params) => {
  return async (dispatch) => {
    const res = await request.delete('sys/permission/role/user/', {
      params,
    })
    console.log(res)
  }
}

export const batchAddOrg = (values) => {
  return async (dispatch) => {
    const res = await request.post('sys/permission/role/org/', values)
    console.log(res)
  }
}

export const batchDelOrg = (params) => {
  return async (dispatch) => {
    const res = await request.delete('sys/permission/role/org/', {
      params,
    })
    console.log(res)
  }
}

export const getMenuPower = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/permission/role/menu/', {
      params,
    })
    dispatch({
      type: GETPERMISSIONMENULIST,
      payload: res.data.data,
    })
  }
}

export const addMenuPower = (values) => {
  return async (dispatch) => {
    const res = await request.post('sys/permission/role/menu/', values)
    console.log(res)
  }
}

export const getFucPower = (params) => {
  return async (dispatch) => {
    const res = await request.get('sys/permission/role/func/', {
      params,
    })
    dispatch({
      type: GETPERMISSIONFUCLIST,
      payload: res.data.data,
    })
  }
}

export const addFucPower = (values) => {
  return async (dispatch) => {
    const res = await request.post('sys/permission/role/func/', values)
    console.log(res)
  }
}

export const getTrigger = (params, isLoading) => {
  return async (dispatch) => {
    return await request.get('sys/permission/role/check/', {
      params,
      isLoading,
    })
  }
}
